import React from 'react'

import { createRegisterableComponent } from '@news-mono/web-common'
import { Sharing } from './Sharing'
import { ShareOption } from '@news-mono/web-common'

export interface SharingRouteProps {
    url: string
    text: string

    shareOptions: ShareOption[]
    isGhostStyle?: boolean
    isSticky?: boolean
    layout?: 'stacked-md-desktop'
}

export const SharingRegistration = createRegisterableComponent(
    'sharing',
    (props: SharingRouteProps, services) => {
        return (
            <Sharing
                url={props.url}
                text={props.text}
                onEvent={services.onEvent}
                shareOptions={props.shareOptions}
                isGhostStyle={props.isGhostStyle}
                isSticky={props.isSticky}
                layout={props.layout}
            />
        )
    },
)
